;(function () {
  'use strict'

  angular
    .module('surfsightApp.controllers')

    .controller('healthReportsAlarmsNotificationsController', [
      '$scope',
      '$rootScope',
      '$log',
      '$state',
      '$timeout',
      '$interval',
      '$location',
      '$http',
      '$q',
      '$filter',
      '$localStorage',
      '$mdDialog',
      '$mdSidenav',
      '$mdToast',
      function (
        $scope,
        $rootScope,
        $log,
        $state,
        $timeout,
        $interval,
        $location,
        $http,
        $q,
        $filter,
        $localStorage,
        $mdDialog,
        $mdSidenav,
        $mdToast
      ) {
        $scope.staticData = {
          alarmDefinitions: [],
          availableReportIntervals: [0.5, 1, 4, 8, 12, 24, 48, 168].map(h => ({
            value: h * 60 * 60,
            title: moment.duration({ h }).humanize()
          }))
        }
        const availableTabs = [
          {
            id: 'recipientsList',
            title: 'Alarms Report Emails',
            index: 0
          },
          {
            id: 'configureRecipient',
            title: 'Configure Mail Alarms',
            index: 1
          },
          {
            id: 'addRecipient',
            title: 'Add Recipient',
            index: 2
          },
          {
            id: 'confirmAction',
            title: 'Confirm Action',
            index: 3
          }
        ]
        $scope.getRecipientsStatus = {
          loading: false,
          error: false
        }
        $scope.recipients = []
        const getRecipients = () => {
          const requestQueryParams = new window.URLSearchParams()
          requestQueryParams.set(
            'organizationId',
            $rootScope.currentUserOrganization.id
          )
          Object.assign($scope.getRecipientsStatus, {
            loading: true,
            error: false
          })
          $scope.getRecipientsStatus.loading = true
          const requestJson = {
            method: 'GET',
            url: `${DEVICE_BASEURL}/organizations/alarms-recipients?${requestQueryParams.toString()}`
          }
          $http(requestJson)
            .then(({ data }) => {
              $scope.recipients = data.data
            })
            .catch(error => {
              Object.assign($scope.getRecipientsStatus, {
                error: 'Unable to load recipients'
              })
              handleServerError(error)
            })
            .finally(() => {
              Object.assign($scope.getRecipientsStatus, {
                loading: false
              })
            })
        }
        const loadAlarmDefinitions = async () => {
          if ($scope.staticData.alarmDefinitions.length) return
          try {
            const { data } = await $http({
              method: 'GET',
              url: `${DEVICE_BASEURL}/alarm-definitions`
            })
            $scope.staticData.alarmDefinitions = data.data.map(ad => ({
              ...ad,
              realTimeAlert: true
            }))
          } catch (error) {
            handleServerError(error)
          }
        }
        loadAlarmDefinitions()
        $scope.toggleUpdatingRecipientAlarmDefinition = alarmDefinition => {
          const index = $scope.updatingRecipient.alarmDefinitions.findIndex(
            ad => ad.id === alarmDefinition.id
          )
          if (index === -1) {
            $scope.updatingRecipient.alarmDefinitions.push({
              id: alarmDefinition.id
            })
          } else {
            $scope.updatingRecipient.alarmDefinitions.splice(index, 1)
          }
          $scope.updatingRecipient.alarmDefinitionIds = $scope.updatingRecipient.alarmDefinitions.map(
            ad => ad.id
          )
        }
        $scope.saveRecipientStatus = {
          loading: false
        }
        $scope.saveRecipient = () => {
          const isNewRecipient = !$scope.updatingRecipient.id
          const requestJson = {
            method: isNewRecipient ? 'POST' : 'PATCH',
            url: `${DEVICE_BASEURL}/organizations/alarms-recipients${
              isNewRecipient
                ? `?organizationId=${$rootScope.currentUserOrganization.id}`
                : `/${$scope.updatingRecipient.id}`
            }`,
            data: [
              'id',
              'email',
              'reportIntervalSeconds',
              'alarmDefinitions'
            ].reduce((acc, key) => ({
              ...acc,
              [key]: $scope.updatingRecipient[key]
            }))
          }
          $http(requestJson)
            .then(({ data }) => {
              $scope.selectTab('recipientsList', null, { refresh: true })
              showMessageToast(data.status.error)
            })
            .catch(error => {
              if (error.data && error.data.status) {
                showMessageToast(error.data.status.error)
              }
              handleServerError(error)
            })
        }
        const deleteRecipient = (recipient, actionState = {}) => {
          Object.assign(actionState, {
            loading: true
          })
          const requestJson = {
            method: 'DELETE',
            url: `${DEVICE_BASEURL}/organizations/alarms-recipients/${recipient.id}`,
            data: {}
          }
          $http(requestJson)
            .then(({ data }) => {
              $scope.selectTab('recipientsList', null, { refresh: true })
              showMessageToast(data.status.error)
            })
            .catch(error => {
              if (error.data && error.data.status) {
                showMessageToast(error.data.status.error)
              }
              handleServerError(error)
            })
            .finally(() => {
              Object.assign(actionState, {
                loading: false
              })
            })
        }
        $scope.selectTab = (id, data = {}, config = {}) => {
          config = {
            refresh: false,
            ...config
          }
          switch (id) {
            case 'recipientsList':
              config.refresh && getRecipients()
              break
            case 'configureRecipient':
              $scope.updatingRecipient = {
                ...data,
                alarmDefinitionIds: data.alarmDefinitions.map(ad => ad.id)
              }
              $scope.saveRecipientStatus.loading = false
              break
            case 'addRecipient':
              $scope.newRecipient = {
                email: null,
                reportIntervalSeconds: null,
                alarmDefinitions: []
              }
              break
            case 'confirmAction':
              switch (data.action) {
                case 'deleteRecipient':
                  $scope.confirmAction = {
                    message: `Do you want to delete the recipient (${data.recipient.email}) ?`,
                    yes: () => {
                      deleteRecipient(
                        data.recipient,
                        $scope.confirmAction.state
                      )
                    },
                    no: () => {
                      $scope.selectTab('recipientsList')
                    },
                    state: {
                      loading: false
                    }
                  }
                  break
                default:
                  throw new Error('Action not found')
              }
              break
            default:
              throw new Error('Tab not found')
          }
          const index = availableTabs.findIndex(t => t.id === id)
          $scope.selectedTab = {
            index,
            tab: availableTabs[index]
          }
        }
        $scope.selectTab('recipientsList', null, { refresh: true })
        $scope.showEditRecipient = recipient => {
          $scope.selectTab('configureRecipient', recipient)
        }
        $scope.configureNewRecipientEmail = () => {
          const exists = $scope.recipients.some(
            recipient =>
              recipient.email.toLowerCase() ===
              $scope.newRecipient.email.toLowerCase()
          )
          if (exists) {
            return showMessageToast('Recipient with the email already exists.')
          }
          $scope.selectTab('configureRecipient', $scope.newRecipient)
        }
        $scope.showDeleteRecipient = recipient => {
          $scope.selectTab('confirmAction', {
            action: 'deleteRecipient',
            recipient
          })
        }

        const showMessageToast = (message, parentContainer = null) => {
          const toast = $mdToast
            .simple()
            .textContent(message)
            .action('ok')
            .parent(
              angular.element(
                document.getElementById('alarms-recipients-container')
              )
            )
            .position('bottom left')
            .hideDelay(5000)

          $mdToast
            .show(toast)
            .then(() => {})
            .catch(() => {})
        }
        $scope.cancel = function () {
          $mdDialog.cancel()
        }
        const handleServerError = error => {
          $scope.$emit('handleServerError', error)
        }
      }
    ])
})()
